// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1855) return "js/datadog-browser-rum.js";
	if (chunkId === 8568) return "js/datadog-browser-logs.js";
	if (chunkId === 3453) return "js/web-vitals.js";
	// return url for filenames based on template
	return undefined;
};